import { Card, Image } from 'react-bootstrap';
import icImgPreview from '../../../assets/img/ic-img.svg';
import gptwBanner from '../../../assets/img/gptw-banner.svg';
import icApproved from '../../../assets/img/ic-check-circle.svg';
import icRejected from '../../../assets/img/ic-close-circle.svg';
import icRLifecycleReview from '../../../assets/img/ic-lyfecycle-review.svg';
import icUnderReview from '../../../assets/img/ic-under-review.svg';

// Shared compact hero for the mobile Discovery company-detail tree (Company
// Info / Hiring Info / Jobs tabs). Logo, name, website and the GPTW badge
// are always shown; administrative metadata (General Info heading, Access
// Level, approval/active status) only renders for isAdminViewer.
const CompanyDetailHero = ({ company, isAdminViewer, onWebsiteClick }) => {
    if (!company) return null;

    const logo = company.logo || '';
    const title = company.title || company.name || '';
    const url = company.url || '';
    const approvalStatus = String(company.accountApprovalStatus || '').toLowerCase();
    const rating = parseFloat(company.bestPlacetoWorkRating || 0);

    return (
        <Card className="company-detail-hero">
            <div className="card-premium">
                <Card.Body>
                {isAdminViewer && (
                    <div className="company-detail-hero-header">
                        <h3>General Info</h3>
                    </div>
                )}
                <div className="company-detail-hero-content">
                    <div className="upload-image-wrapper">
                        <div className="upload-preview not-editing">
                            <Image
                                src={logo.trim() ? logo : icImgPreview}
                                alt={title || 'Company Logo'}
                                roundedCircle
                                className="preview-image"
                                onError={(e) => { e.currentTarget.src = icImgPreview; }}
                            />
                        </div>
                    </div>
                    <div className="company-detail-hero-details">
                        <h1>{title || '—'}</h1>
                        {url && (
                            <p className="company-detail-hero-metadata">
                                <a
                                    href={url.startsWith('http') ? url : `https://${url}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={onWebsiteClick}
                                >
                                    {url}
                                </a>
                                {isAdminViewer && company.accessLevel && (
                                    <>
                                        <span className="dot"></span>
                                        Access Level:&nbsp;<strong>{company.accessLevel}</strong>
                                    </>
                                )}
                            </p>
                        )}
                        {isAdminViewer && (
                            <div className="status-wrapper">
                                <div className="company-detail-hero-statuses">
                                    <span className={
                                        approvalStatus === 'approved' ? 'approved' :
                                        approvalStatus === 'rejected' ? 'rejected' :
                                        approvalStatus === 'lifecycle review' ? 'lifecycle-review' :
                                        approvalStatus === 'under review' ? 'under-review' : ''
                                    }>
                                        <span className="d-flex align-items-center gap-2">
                                            {approvalStatus === 'approved' && <img src={icApproved} alt="Approved" />}
                                            {approvalStatus === 'rejected' && <img src={icRejected} alt="Rejected" />}
                                            {approvalStatus === 'lifecycle review' && <img src={icRLifecycleReview} alt="Lifecycle Review" />}
                                            {approvalStatus === 'under review' && <img src={icUnderReview} alt="Under Review" />}
                                            {company.accountApprovalStatus}
                                        </span>
                                    </span>
                                    <span className="company-detail-hero-activity-row">
                                        <span className={`badge ${company.activityStatus ? 'bg-active' : 'bg-inactive'}`}>
                                            {company.activityStatus ? 'Active' : 'Inactive'}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {rating > 89 && (
                    <div className="company-detail-hero-gptw d-flex align-items-center justify-content-center mt-3">
                        <div className="gptw-badge d-flex align-items-center">
                            <div className="gptw-logo">
                                <Image src={gptwBanner} alt="Great Place to Work" />
                            </div>
                            <div className="gptw-text-circle">
                                <div className="gptw-circle position-relative">
                                    <svg width="80" height="80" viewBox="0 0 36 36">
                                        <circle
                                            cx="18" cy="18" r="16" fill="none"
                                            stroke="#ec1c24" strokeWidth="4"
                                            strokeDasharray={`${rating} 100`}
                                            strokeDashoffset="0"
                                            transform="rotate(-90 18 18)"
                                        />
                                        <circle
                                            cx="18" cy="18" r="16" fill="none"
                                            stroke="#d0d3d4" strokeWidth="4"
                                            strokeDasharray={`${100 - rating} 100`}
                                            strokeDashoffset={`-${rating}`}
                                            transform="rotate(-90 18 18)"
                                            strokeLinecap="square"
                                        />
                                    </svg>
                                    <div className="gptw-percentage position-absolute top-50 start-50 translate-middle fw-bold">
                                        {`${Math.round(rating)}%`}
                                    </div>
                                </div>
                                <div className="gptw-text">
                                    <span className="fw-bold text-dark">
                                        Employees say this is a great place to work
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                </Card.Body>
            </div>
        </Card>
    );
};

export default CompanyDetailHero;
